import { render, staticRenderFns } from "./TertiaryButton.vue?vue&type=template&id=c1d7184a&"
import script from "./TertiaryButton.vue?vue&type=script&lang=ts&"
export * from "./TertiaryButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports